import { render, staticRenderFns } from "./BrandHeader.vue?vue&type=template&id=93f6d3b8&scoped=true&"
import script from "./BrandHeader.vue?vue&type=script&lang=js&"
export * from "./BrandHeader.vue?vue&type=script&lang=js&"
import style0 from "./BrandHeader.vue?vue&type=style&index=0&id=93f6d3b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f6d3b8",
  null
  
)

export default component.exports